<template>
  <v-main>
    <v-container v-if="!loading">
      <v-toolbar class="elevation-0 mb-3 b-sm-0">
        <div class="pl-0 ml-n4 d-flex align-start align-sm-center flex-column flex-sm-row">
          <span class="headline mr-4">Fatura</span>

          <v-chip small :color="(fields.invoice_status === 'paid') ? 'success' : (fields.invoice_status === 'pending') ? 'primary' : 'error'">
            {{ fields.invoice_status | invoice_status }}
          </v-chip>
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex mr-1 align-center">
          <v-btn v-if="fields.invoice_url" text color="primary" :href="fields.invoice_url" target="_blank">
            <v-icon left>mdi-barcode</v-icon> Abrir Fatura
          </v-btn>
        </div>
        <div class="d-flex mr-1 align-center">
          <v-btn v-if="fields.invoice_status === 'pending' || fields.invoice_status === 'late'" text color="primary" :to="{ name: 'updateInvoice', params: { id } }">
            <v-icon left>mdi-pencil</v-icon> Editar Fatura
          </v-btn>
        </div>
        <div class="d-flex mr-1 align-center">
          <v-btn v-if="fields.invoice_url" :disabled="!canUpdatePaymentMethod" text color="primary" @click="() => { paymentMethodModal = true }">
            <v-icon left>mdi-cash-sync</v-icon> Editar forma pagto
          </v-btn>
        </div>
        <div class="d-flex mr-n4 align-center">
          <v-btn v-if="!fields.invoice_url && fields.invoice_status === 'paid'" text color="error" @click="() => { deletePaidValueModal = true }">
            <v-icon left>mdi-delete</v-icon> Excluir valor pago
          </v-btn>
          <v-btn v-if="fields.invoice_url &&  (fields.invoice_status === 'pending' || fields.invoice_status === 'late')" text color="error" @click="() => { cancelModal = true }">
            <v-icon left>mdi-delete</v-icon> Cancelar Fatura
          </v-btn>
        </div>
      </v-toolbar>
      <div>
        <v-row>
          <v-col md="3">
            <small>Valor</small>
            <br>
            <span class="title">{{ fields.total_amount | price }}</span>
          </v-col>
          <v-col md="3">
            <small>Total sem juros</small>
            <br>
            <span class="title">{{ fields.total_amount - fields.total_interest_and_fines | price }}</span>
          </v-col>
          <v-col md="3">
            <small>Multa e juros</small>
            <br>
            <span class="title">{{ fields.total_interest_and_fines | price }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="3">
            <small>Data de Competência</small>
            <br>
            <b>{{ fields.invoice_date | moment('MMMM [de] YYYY') }}</b>
          </v-col>
          <v-col md="3">
            <small>Data de Vencimento</small>
            <br>
            <b>{{ fields.due_date | moment('DD/MM/YYYY') }}</b>
          </v-col>
          <v-col md="3">
            <small>Gerada em</small>
            <br>
            <b>{{ fields.created_at | moment('DD/MM/YYYY') }}</b>
          </v-col>
          <v-col md="3">
            <small>Data do Pagamento</small>
            <br>
            <b>{{ fields.payment_date | moment('DD/MM/YYYY HH:mm') }}</b>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6">
            <small>Nome</small>
            <br>
            <b>{{ fields.customer.name }} </b>
            <span>({{ fields.customer.nickname }})</span>
          </v-col>
          <v-col md="3">
            <small>CPF/CNPJ</small>
            <br>
            <b>{{ fields.customer.person_document | document }}</b>
          </v-col>
          <v-col md="3">
            <small>Telefone</small>
            <br>
            <b>{{ fields.customer.phone_number | phone_number }}</b>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="3">
            <small>Turma</small>
            <br>
            <b>{{ fields.celebration.name }}</b>
          </v-col>
          <v-col md="9">
            <small>Observações (Motivo de cancelamento e outros)</small>
            <br>
            <b>{{ (fields.notes) ? fields.notes : '-' }}</b>
          </v-col>
        </v-row>
        <br>
        <span class="title">Conta Heppi</span>
        <v-row>
          <v-col md="4">
            <small>Nome</small>
            <br>
            <b>{{ fields.account.name }}</b>
          </v-col>
          <v-col md="4">
            <small>Número</small>
            <br>
            <b>{{ fields.account.account_number }}</b>
          </v-col>
          <v-col md="4">
            <small>Proprietário</small>
            <br>
            <b>{{ fields.account.owner.name }} | {{ fields.account.owner.document | document }}</b>
          </v-col>
        </v-row>
        <v-tabs
          v-model="tab"
          center-active
          class="pb-5"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab key="tab-items" href="#tab-items">Itens</v-tab>
          <v-tab key="tab-fees" href="#tab-fees">Taxas</v-tab>
          <v-tab key="tab-gateway-responses" href="#tab-gateway-responses">Respostas do Gateway</v-tab>
          <v-tab key="tab-logs" href="#tab-logs">Logs</v-tab>
          <v-tab-item key="tab-item-items" value="tab-items">
            <v-list>
              <v-list-item v-for="(item, index) in fields.items" :key="index" @click="() => {}">
                <v-list-item-content class="align-center">
                  <v-row>
                    <v-col md="6">
                      <v-list-item-title>{{ item.description }}</v-list-item-title>
                      <small>{{ item.notes }}</small>
                    </v-col>
                    <v-col md="6" class="text-right text-vertical-center">
                      <b>{{ item.installment_amount | price }}</b>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-tab-item>
          <v-tab-item key="tab-item-fees" value="tab-fees">
            <v-list>
              <v-list-item v-for="(fee, index) in fields.fees" :key="index" @click="() => {}">
                <v-list-item-content class="align-center">
                  <v-row>
                    <v-col md="6">
                      <v-list-item-title>{{ fee.type | fee_type }}</v-list-item-title>
                    </v-col>
                    <v-col md="6" class="text-right">
                      <b v-if="fee.method === 'tax'">{{ fee.fee | price }}</b>
                      <b v-if="fee.method === 'percent'">{{ fee.fee | percent }}</b>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-tab-item>
          <v-tab-item key="tab-item-gateway-responses" value="tab-gateway-responses">
            <v-data-table
              :headers="gatewayResponsesHeaders"
              :items="fields.gateway_responses"
              show-expand
              class="mb-4"
            >
              <template v-slot:item.date_created="{ item }">
                {{ item.date_created | moment('DD/MM/YYYY HH:mm') }}
              </template>
              <template v-slot:item.date_approved="{ item }">
                {{ item.date_approved | moment('DD/MM/YYYY HH:mm') }}
              </template>
              <template v-slot:item.money_release_date="{ item }">
                {{ item.money_release_date | moment('DD/MM/YYYY HH:mm') }}
              </template>
              <template v-slot:item.status="{ item }">
                {{ item.status | gateway_response_status }}
              </template>
              <template v-slot:item.transaction.total_paid_amount="{ item }">
                {{ item.transaction.total_paid_amount | price }}
              </template>
              <template v-slot:expanded-item="{ item }">
                <td><b>Código: </b>{{ item.transaction.verification_code }}</td>
                <td><b>URL: </b>{{ item.transaction.external_resource_url }}</td>
                <td><b>Parcelas: </b>{{ item.transaction.installment_amount }}</td>
                <td><b>Valor pago em excesso: </b>{{ item.transaction.overpaid_amount }}</td>
                <td><b>Valor líquido recebido: </b>{{ item.transaction.net_received_amount | price }}</td>
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item key="tab-item-logs" value="tab-logs">
            <small v-if="fields.logs.length === 0">Sem logs no momento</small>
            <v-list>
              <v-list-item v-for="(log, index) in logs" :key="index" @click="() => {}">
                <v-list-item-content class="align-center">
                  <v-row>
                    <v-col md="6">
                      <v-list-item-title>{{ log.description }}</v-list-item-title>
                      <small>{{ log.notes }}</small>
                    </v-col>
                    <v-col md="6" class="text-right">
                      <b>{{ log.created_at | moment('DD/MM/YYYY HH:mm:ss') }}</b>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-tab-item>
        </v-tabs>
      </div>
    </v-container>
    <v-dialog :value="paymentMethodModal" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">Editar Forma de Pagamento</v-card-title>
        <v-card-text class="pb-0">
          <v-checkbox
            label="Boleto"
            v-model="paymentMethods.bankSlip"
            color="primary"
          ></v-checkbox>
          <v-checkbox
            label="PIX"
            v-model="paymentMethods.pix"
            color="primary"
          ></v-checkbox>
          <v-checkbox
            label="Cartão de Crédito"
            v-model="paymentMethods.creditCard"
            color="primary"
          ></v-checkbox>
          <v-select
            v-if="paymentMethods.creditCard"
            label="Quantidade de parcelas"
            v-model="paymentMethods.installments"
            :items="paymentMethodsOptions"
            outlined dense
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" :disabled="updatingPaymentMethods" text @click="paymentMethodModal = false">
            Desistir
          </v-btn>
          <v-btn color="primary" :disabled="updatingPaymentMethods" :loading="updatingPaymentMethods" text @click="updatePaymentMethods()">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog :value="cancelModal" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">Cancelar Fatura</v-card-title>
        <v-card-text class="pb-0">
          <v-textarea
            outlined
            label="Motivo do cancelamento *"
            v-model="cancelReason"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" :disabled="canceling" text @click="cancelModal = false">
            Desistir
          </v-btn>
          <v-btn color="error" :disabled="canceling" :loading="canceling" text @click="cancelInvoice()">
            Cancelar Fatura
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog :value="deletePaidValueModal" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">Excluir valor pago</v-card-title>
        <v-card-text class="pb-0">
          <p>Você tem certeza que deseja excluir o valor pago informado?</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" :disabled="canceling" text @click="deletePaidValueModal = false">
            Desistir
          </v-btn>
          <v-btn color="error" :disabled="canceling" :loading="canceling" text @click="deletePaidValue()">
            Excluir valor pago
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <app-loading :visible="loading"></app-loading>
  </v-main>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapMutations } from 'vuex'

import AppLoading from '@/components/Loading'

export default {
  name: 'invoiceDetails',
  components: {
    AppLoading
  },
  props: ['id'],
  data () {
    return {
      tab: 'tab-items',
      loading: false,
      deletePaidValueModal: false,
      cancelModal: false,
      cancelReason: '',
      canceling: false,
      canUpdatePaymentMethod: false,
      paymentMethodModal: false,
      paymentMethods: {
        bankSlip: false,
        pix: false,
        creditCard: false,
        installments: 1
      },
      paymentMethodsOptions: [
        { value: 1, text: 'Em 1x' },
        { value: 2, text: 'Em até 2x' },
        { value: 3, text: 'Em até 3x' },
        { value: 4, text: 'Em até 4x' },
        { value: 5, text: 'Em até 5x' },
        { value: 6, text: 'Em até 6x' },
        { value: 7, text: 'Em até 7x' },
        { value: 8, text: 'Em até 8x' },
        { value: 9, text: 'Em até 9x' },
        { value: 10, text: 'Em até 10x' },
        { value: 11, text: 'Em até 11x' },
        { value: 12, text: 'Em até 12x' }
      ],
      updatingPaymentMethods: false,
      fields: {
        id: '',
        invoice_date: '',
        due_date: '',
        payment_date: '',
        invoice_url: '',
        invoice_status: '',
        total_amount: 0,
        total_interest_and_fines: 0,
        notes: '',
        customer: {
          id: '',
          name: '',
          nickname: '',
          email: '',
          phone_number: '',
          person_document: ''
        },
        celebration: {
          name: '',
          id: '',
          creditCard: '',
          bankSlip: '',
          pix: '',
          gateway_id: ''
        },
        account: {
          name: '',
          account_number: '',
          owner: {
            name: '',
            document: ''
          }
        },
        gateway_responses: [],
        items: [],
        fees: [],
        logs: [],
        created_at: ''
      },
      gatewayResponsesHeaders: [
        { text: 'Criado em', value: 'date_created' },
        { text: 'Aprovado em', value: 'date_approved' },
        { text: 'Liberação do dinheiro', value: 'money_release_date' },
        { text: 'Status', value: 'status' },
        { text: 'Tipo de pagamento', value: 'payment_type' }, // colocar installments,
        { text: 'Total Pago', value: 'transaction.total_paid_amount' }
      ]
    }
  },
  computed: {
    ...mapGetters(['user', 'userEmail']),
    logs () {
      const cp = [ ...this.fields.logs ]

      cp.sort((a, b) => {
        if (this.$moment(a.created_at).isBefore(b.created_at)) return 1
        return -1
      })

      return cp
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    getData () {
      this.loading = true

      axios.get('invoices/' + this.id)
        .then(response => {
          if (response.data) {
            this.loading = false
            for (let key in this.fields) {
              if (response.data[key]) this.fields[key] = response.data[key]
            }

            if (this.fields.celebration && this.fields.celebration.id) {
              axios.get('celebrations/' + this.fields.celebration.id)
                .then(celeb => {
                  if (celeb.data) {
                    this.fields.celebration.creditCard = celeb.data.credit_card
                    this.fields.celebration.bankSlip = celeb.data.bank_slip
                    this.fields.celebration.pix = celeb.data.pix
                    this.fields.celebration.gateway_id = celeb.data.gateway_id
                    this.canUpdatePaymentMethod = true
                  }
                })
            }
          } else {
            this.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
            this.$router.push({ name: 'invoices' })
          }
        })
        .catch(() => {
          this.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
          this.$router.push({ name: 'invoices' })
        })
        .finally(() => {
          this.loading = false
        })
    },
    updatePaymentMethods () {
      this.updatingPaymentMethods = true

      const payment_methods = []
      if (this.paymentMethods.bankSlip) {
        payment_methods.push({
          type: 'bank_slip',
          installment: 1,
          processing_mode: this.fields.celebration.bankSlip
        })
      }
      if (this.paymentMethods.pix) {
        payment_methods.push({
          type: 'pix',
          installment: 1,
          processing_mode: this.fields.celebration.pix
        })
      }
      if (this.paymentMethods.creditCard) {
        payment_methods.push({
          type: 'credit_card',
          installment: this.paymentMethods.installments,
          processing_mode: this.fields.celebration.creditCard
        })
      }

      axios.patch(`invoices/${this.fields.invoice_url.replace('https://fatura.heppi.io/', '')}?api_key=${this.fields.celebration.gateway_id}`, {
        invoice_date: this.fields.invoice_date,
        due_date: this.fields.due_date,
        payment_methods
      }, { baseURL: 'https://payment-gateway-api.heppi.io/api/' })
        .then(() => {
          this.SET_SNACKBAR({ text: 'Forma de pagamento alterada' })
          this.getData()
        })
        .catch(() => {
          this.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
        })
        .finally(() => {
          this.updatingPaymentMethods = false
          this.paymentMethodModal = false
        })
    },
    cancelInvoice () {
      this.canceling = true
      const dateNow = this.$moment().format('DD/MM/YYYY HH:mm')

      axios.put(`invoices/${this.fields.id}/cancel`, {
        notes: this.cancelReason + ' - ' + this.user + ' (' + this.userEmail + ') - ' + dateNow
      })
        .then(() => {
          this.SET_SNACKBAR({ text: 'Fatura cancelada com sucesso.' })
          this.getData()
        })
        .catch(() => {
          this.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
        })
        .finally(() => {
          this.canceling = false
          this.cancelModal = false
        })
    },
    deletePaidValue () {
      this.canceling = true

      axios.delete(`invoices/paid/third-parties/${this.fields.id}`)
        .then(() => {
          this.SET_SNACKBAR({ text: 'Valor pago excluido com sucesso.' })
          this.$router.go(-1)
        })
        .catch(() => {
          this.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
        })
        .finally(() => {
          this.canceling = false
          this.deletePaidValueModal = false
        })
    }
  },
  created () {
    this.getData()
  }
}
</script>
